import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Card } from '@/src/elements/card'
import { Typography } from '@/src/elements/text/Typography'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'

import { DonationProgress } from '../DonationProgress'
import type { TDonationBannerBaseProps } from './DonationBanner.types'

export const DesktopDonationBanner = ({
  donationData,
  messages,
  notes,
  signature,
  onClose,
  onDonate,
  onDonateLater,
}: TDonationBannerBaseProps): ReactNode => (
  <Card className="max-w-screen bg-white p-8" testID={TEST_ID.DONATION.BANNER}>
    <Button
      className="absolute right-5 top-5 z-10 border-none"
      isIconOnly
      startIcon={ICON.CLOSE}
      colors="default"
      variant="light"
      contrast="low"
      size="md"
      onPress={onClose}
    />
    <View className="m-auto flex max-w-screen-xl flex-1 flex-row gap-8">
      <View className="flex-column max-w-7/12 flex md:w-6/12 lg:w-7/12">
        <DonationProgress className="mb-7 w-full px-3 py-3" donationData={donationData} />
        {messages.map((message, index) => {
          const messageKey = `desktop-message-${index}`
          return (
            <Typography key={messageKey} colors="secondary" size="md" contrast="high" className="px-3 py-2">
              {message}
            </Typography>
          )
        })}
        <Typography colors="secondary" size="md" contrast="high" className="px-3 py-2">
          {signature}
        </Typography>
      </View>
      <View className="flex-column flex flex-1 justify-center gap-3 pr-7">
        <View className="flex-column flex flex-1 items-center justify-center gap-8">
          <Typography colors="secondary" size="md" contrast="high" className="px-3 py-2">
            {notes}
          </Typography>
          <Button
            startIcon={ICON.HEART}
            id={TEST_ID.DONATION.DONATE_BUTTON}
            testID={TEST_ID.DONATION.DONATE_BUTTON}
            colors="danger"
            size="md"
            className="w-full max-w-[200px]"
            onPress={onDonate}
          >
            <FormattedMessage id="app.i-donate" />
          </Button>
        </View>
        <Button startIcon={ICON.BELL} colors="danger" size="sm" variant="light" onPress={onDonateLater}>
          <FormattedMessage id="app.donation.later.i-want" />
        </Button>
      </View>
    </View>
  </Card>
)
